import { SVGProps, Ref, forwardRef } from 'react';

export const SendAndroidFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M23.734 10.696 10.372 4.108C5.587 1.748 3.194.568 1.928 1.874.663 3.179 1.55 5.912 3.324 11.378l.331 1.02L19.496 16l-15.84 3.6-.332 1.023C1.55 26.088.664 28.82 1.928 30.126c1.266 1.305 3.659.125 8.444-2.234l13.362-6.588c4.622-2.279 6.933-3.418 6.933-5.304s-2.311-3.026-6.933-5.304"
                fill="currentColor"
            />
        </g>
    </svg>
));
SendAndroidFilledSize32Glyph.displayName = 'SendAndroidFilledSize32Glyph';
